import { Container } from '@cgs/wge';
import {
  T_IFreeSpinsModeProvider,
  T_IFreeSpinsPopupViewUpdater,
  T_ISpinParams,
} from '../../../../type_definitions';
import { IFreeSpinsModeProvider } from '../../free_spins/i_free_spins_mode_provider';
import { IFreeSpinsPopupViewUpdater } from '../../free_spins/i_free_spins_popup_view_updater';
import { EndFreeSpinsPopupView } from './end-free-spins-popup.view';
import { BaseSlotPopupController } from '../../../common/slot/controllers/base_popup_controller';
import { GameStateMachineStates } from '../../../../reels_engine/state_machine/game-state-machine-states';
import { ISpinParams } from '../../../../reels_engine/game_components/i_spin_params';
import { EndFreeSpinsPopupParams } from './end-free-spins-popup.typings';

export class EndFreeSpinsPopupController extends BaseSlotPopupController<EndFreeSpinsPopupView> {
  private readonly _freeSpinsModeProvider: IFreeSpinsModeProvider;
  private readonly _spinParams: ISpinParams;
  private readonly _useFreeSpinMode: boolean;
  private readonly _useViewUpdater: boolean;

  constructor(
    container: Container,
    popupView: EndFreeSpinsPopupView,
    protected readonly params: Partial<EndFreeSpinsPopupParams>
  ) {
    super(container, popupView, !!params.stopBackgroundSound);
    this._useViewUpdater = !!params.useViewUpdater;
    this._freeSpinsModeProvider =
      container.resolve<IFreeSpinsModeProvider>(T_IFreeSpinsModeProvider);
    this._useFreeSpinMode = !!params.useFreeSpinMode;
    this._spinParams = container.resolve<ISpinParams>(T_ISpinParams);
  }

  public async onPopupClosed(): Promise<void> {
    super.onPopupClosed();
    await this.doShare();
  }

  public async doShare(): Promise<void> {
    this.gameStateMachineNotifier.gameStateMachine.resume();
  }

  public onStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.EndOfFreeSpinsPopup:
        this.onEndFreeSpinShown();
        this.gameStateMachineNotifier.gameStateMachine.curResponse.clearWinLines();
        this.gameStateMachineNotifier.gameStateMachine.curResponse.clearWinPositions();
        if (!this.gameStateMachineNotifier.gameStateMachine.curResponse.isFakeResponse)
          this.view.show();

        if (this._spinParams.skipPopups) {
          this.view.startActivator();
        }
        break;
      default:
        break;
    }
  }

  public onEndFreeSpinShown(): void {
    if (
      !this.gameStateMachineNotifier.gameStateMachine.curResponse ||
      this.gameStateMachineNotifier.gameStateMachine.curResponse.isFakeResponse
    ) {
      return;
    }

    if (this._useFreeSpinMode) {
      this.view.postEvent(
        this.gameStateMachineNotifier.gameStateMachine.curResponse.freeSpinsInfo!.name!
      );
    }

    if (this._useViewUpdater) {
      const viewUpdater = this.container.resolve<IFreeSpinsPopupViewUpdater>(
        T_IFreeSpinsPopupViewUpdater
      );
      if (viewUpdater) {
        viewUpdater.updateViewBeforeShowingPopup(this.view.view);
      }
    }

    this.view.setSpins(
      this.gameStateMachineNotifier.gameStateMachine.curResponse.freeSpinsInfo!.totalFreeSpins
    );
    this.view.setTotalWin(
      this.gameStateMachineNotifier.gameStateMachine.curResponse.freeSpinsInfo!.totalWin
    );
    this.view.setMode(
      this.gameStateMachineNotifier.gameStateMachine.curResponse.freeSpinsInfo!.totalWin > 0
    );

    if (this._freeSpinsModeProvider) {
      this.view.setFreeSpinsMode(
        this._freeSpinsModeProvider.modePickerId!,
        this._freeSpinsModeProvider.currentMode || ''
      );
    }
  }

  public onCloseClicked(): void {
    this.view.hide();
  }

  public handleBackKey(): boolean {
    return false;
  }
}
